import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import CommonTablePagination from "../based/CommonTablePagination";
import { INITPAGING, PLATFORM } from "../based/Constants";
import TFUSelect from "../based/inputs/TFUSelect";
import PushingServices from "../based/services/PushingServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Lazada from "./assets/Lazada.png";
import Shopee from "./assets/Shopee.png";
import Tiktok from "./assets/Tiktok.png";

const ProductPushingStatus = {
    Undefined: -1,
    Pending: 0,
    Processing: 1,
    Failed: 2,
    Successed: 3,
};
const pushingProductModel = {
    productId: 0,
    productType: 0,
    name: "",
    appProductId: 0,
    appProductName: "",
    colorName: "",
    productPushingStatus: 0,
    productPushingStatusName: "",
    thumbnail: "",
    printCostDefault: "",
    isTopPick: false,
    productPushingId: false,
    platformProductId: "",
};

const ListTabOption = [
    {
        value: ProductPushingStatus.Undefined,
        label: "Tất cả",
    },
    {
        value: ProductPushingStatus.Pending,
        label: "Đang chờ",
    },
    {
        value: ProductPushingStatus.Processing,
        label: "Đang xử lý",
    },
    {
        value: ProductPushingStatus.Failed,
        label: "Thất bại",
    },
    {
        value: ProductPushingStatus.Successed,
        label: "Thành công",
    },
];

function PushingManageTotal(props) {
    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        value: "/",
                        label: "Trang chủ",
                    },
                    {
                        value: "/pushing-manage",
                        label: "Đẩy sản phẩm",
                    },
                ]}
                title={"Đẩy sản phẩm"}
            />
            <TableTotal />
        </React.Fragment>
    );
}

export default PushingManageTotal;

function TableTotal() {
    const [datas, setDatas] = useState([pushingProductModel]);
    const [paging, setPaging] = useState({ ...INITPAGING, pageNumber: 1, pageSize: 100, status: -1 });

    useEffect(() => {
        getData(paging);
    }, []);

    async function getData(page) {
        let [err, data] = await PushingServices.GetPushingProductTotalModels(page);
        if (!err && data) {
            let { listObjects, paging } = data;
            setDatas(listObjects);
            setPaging(paging);
        } else {
            if (page.pageNumber == 1) {
                setDatas([]);
                setPaging({ ...INITPAGING });
            }
        }
    }

    function handleChangePage(page) {
        let newPaging = {
            ...paging,
            pageNumber: page,
        };
        getData(newPaging);
    }

    function handleChangePageSize(pageSize) {
        let newPaging = {
            ...paging,
            pageNumber: 1,
            pageSize: pageSize,
        };
        getData(newPaging);
    }

    var PushingStatus = {
        Undefined: -1,
        Pending: 0,
        Processing: 1,
        Failed: 2,
        Successed: 3,
    };

    function renderIconPushStatus(item) {
        if (item.pushingStatus == PushingStatus.Successed) {
            switch (item.platform) {
                case PLATFORM.Shopee:
                    return (
                        <div
                            className="image-icon"
                            onClick={(e) => {
                                if (item.platformProductId) {
                                    window.open(`https://shopee.vn/product/${item.shopId}/${item.platformProductId}/`, "_blank");
                                }
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <img src={Shopee} alt="Shopee" />
                            <span>{item.shopName}</span>
                        </div>
                    );
                case PLATFORM.Tiktok:
                    return (
                        <div
                            className="image-icon"
                            onClick={(e) => {
                                if (item.platformProductId) {
                                    window.open(`https://shop.tiktok.com/view/product/${item.platformProductId}`, "_blank");
                                }
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <img src={Tiktok} alt="Tiktok" />
                            <span>{item.shopName}</span>
                        </div>
                    );
                case PLATFORM.Lazada:
                    return (
                        <div
                            className="image-icon"
                            onClick={(e) => {
                                if (item.platformProductId) {
                                    window.open(`https://www.lazada.vn/products/i${item.platformProductId}.html`, "_blank");
                                }
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <img src={Lazada} alt="Lazada" />
                            <span>{item.shopName}</span>
                        </div>
                    );
                default:
                    break;
            }
        } else {
            return (
                <div>
                    <span className="other">
                        {item.pushingStatusName} ({item.platformName}) -
                    </span>
                    <span>{item.shopName}</span>
                </div>
            );
        }
    }

    return (
        <React.Fragment>
            <TableTotalWrapper>
                <div className="table-total">
                    <div className="table-action row">
                        <div className="list-action-section">
                            <div className="list-select-option">
                                <div className="form-group">
                                    <label htmlFor="">Trạng thái</label>
                                    <TFUSelect
                                        options={ListTabOption}
                                        value={paging.status}
                                        onChanged={(value) => {
                                            getData({ ...paging, status: value });
                                        }}
                                        isClearable={false}
                                    />
                                </div>
                            </div>
                            <div className="search-section">
                                <div className="search-area">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="search"
                                        id="search"
                                        placeholder="Tìm kiếm"
                                        value={paging.keyword}
                                        onChange={(e) => {
                                            setPaging({ ...paging, keyword: e.target.value });
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                getData({ ...paging, pageNumber: 1 });
                                            }
                                        }}
                                    />
                                    <i
                                        className="fa fa-search fa-lg"
                                        onClick={(e) => {
                                            getData({ ...paging, pageNumber: 1 });
                                        }}
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {datas && datas.length > 0 ? (
                            datas.map((item, idx) => {
                                let thumb = item.thumbnail;
                                if (thumb) {
                                    thumb = thumb.replace(".jpg", "_crop.webp");
                                }

                                return (
                                    <div className="table-item" key={idx}>
                                        <div className="table-image">
                                            <img src={thumb} alt={item.name} />
                                            {item.artworkCount > 1 && <div className="print-side badge badge-custom">{item.artworkCount} mặt</div>}
                                        </div>
                                        <div className="table-info-product">
                                            <div className="table-name">{item.name}</div>
                                            <div className="table-price">
                                                <span className="sale-price">{item.salePrice > 0 ? Common.formatCurrency(item.salePrice) : ""}</span>
                                                <span className="sell-price">{item.sellPrice > 0 ? Common.formatCurrency(item.sellPrice) : ""}</span>
                                            </div>
                                            <div className="table-status">
                                                {item.productPushModels &&
                                                    item.productPushModels.map((pushItem, pushIdx) => {
                                                        if (pushIdx >= 2) return null;
                                                        return (
                                                            <div className="push-item" key={pushIdx}>
                                                                {renderIconPushStatus(pushItem)}
                                                            </div>
                                                        );
                                                    })}
                                                {item.productPushModels && item.productPushModels.length > 2 && (
                                                    <div className="push-item">
                                                        <span className="other">+{item.productPushModels.length - 2} sàn khác</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="table-action">
                                                <button
                                                    className={`btn btn-orange m-2 ${item.salePrice > 0 ? "" : "disabled"}`}
                                                    onClick={(e) => {
                                                        window.open(`/pushing-multi-detail/${item.designId}`, "_blank");
                                                    }}
                                                >
                                                    Đẩy sản phẩm
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no-item"></div>
                        )}
                    </div>
                    <div className="table-bottom">
                        <CommonTablePagination paging={paging} onChangePage={handleChangePage} onChangePageSize={handleChangePageSize} />
                    </div>
                </div>
            </TableTotalWrapper>
        </React.Fragment>
    );
}

const TableTotalWrapper = styled.div`
    width: 90%;

    .table-action {
        display: flex;
        flex-wrap: wrap;
    }

    .table-image {
        background: white;
    }
    .table-status {
        height: 44px;
        overflow: hidden;
    }
    .image-icon {
        display: flex;
        align-items: center;
        margin: 6px 0;

        span {
            color: #444;
            font-family: Lexend;
            font-size: 11px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
        }

        img {
            height: 16px;
            object-fit: contain;
        }
    }

    .table-body {
        display: flex;
        flex-wrap: wrap;
    }

    .table-item {
        min-width: 190px;
        border-radius: 12px;
        overflow: hidden;
        margin: 12px 12px 12px 0;
        width: calc(100% / 7 - 12px);
    }

    .table-image {
        width: 100%;
        position: relative;
    }

    .table-image img {
        width: 100%;
        object-fit: contain;
    }

    .print-side {
        position: absolute;
        left: 5px;
        bottom: 5px;
    }

    .table-info-product {
        padding: 8px 10px;
        background: white;
    }

    .table-name {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        height: 38px;
    }

    span.sale-price {
        overflow: hidden;
        color: #ff9027;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    span.sell-price {
        overflow: hidden;
        color: #a0a0a0;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-decoration: line-through;
        margin-left: 4px;
    }

    .table-price {
        margin: 6px 0;
    }

    button.btn.btn-orange {
        width: calc(100% - 0.5rem);
        border-radius: 8px;
        background: #ff9027;
        border: none;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .table-action.row {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px;
        margin: 12px 0;
    }

    .list-action-section {
        display: flex;
        width: 100%;
    }

    .search-section {
        margin-left: auto;
        display: flex;
        align-items: flex-end;
    }

    .list-select-option .form-group {
        width: 204px;
    }

    .search-area {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 4px 10px;
        width: 338px;
    }

    .search-area input {
        border: none;
    }
`;
